import { Button } from '@mantine/core';
import { IconFileTypeXls } from '@tabler/icons-react';

import { Id } from '@feature/utils';

import { getGovEvaluationAutomatedAnnexDownloadUrl } from '../model/GovEvaluationApi';

interface EvaluationAutomatedAnnexButtonProps {
  evaluationId: Id;
  authorId: Id;
  annexType: string;
}

const onDownload = (evaluationId: Id, authorId: Id, type: string) => {
  window.open(getGovEvaluationAutomatedAnnexDownloadUrl(evaluationId, authorId, type));
};

export function GovEvaluationAutomatedAnnexButton({
  evaluationId,
  authorId,
  annexType,
}: EvaluationAutomatedAnnexButtonProps) {
  return (
    <Button
      size="xs"
      leftSection={<IconFileTypeXls size="24px" />}
      onClick={() => onDownload(evaluationId, authorId, annexType)}
    >
      Descarcă anexă precompletată
    </Button>
  );
}
